module.exports = __webpack_public_path__ + "img/2-7.1dffc242.png";